import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface CardProps {
    className?: string;
    children: ReactNode;
    onClick?: () => void;
}

export const Card = ({ className, children, onClick }: CardProps) => {
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <div
            // bg-neutral-0 defaults to the "inset" card surface (= --neutral-0, same as the page bg).
            // For "raised" inner cards (e.g. SuperAdmin programme overview's inner cards), pass
            // `className="bg-neutral-100"` to override.
            className={clsx('bg-neutral-0 overflow-hidden rounded-lg', className)}
            onClick={onClick}
            onKeyDown={onClick ? handleKeyDown : undefined}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            {children}
        </div>
    );
};

export default Card;
